<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${heroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Step Into Style</div>
          <div class="hero-desc">
            Discover premium men's footwear — formal shoes, casual sneakers, elegant loafers, traditional Peshawari chappals, and Chelsea boots. Elevate every step with ZALODES.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
      </div>
    </div>

    <!-- Featured Categories Strip -->
    <div class="featured-strip">
      <div class="featured-strip-inner">
        <router-link class="featured-item" to="/goods?category=200">
          <div class="featured-icon">👞</div>
          <span>Formal</span>
        </router-link>
        <router-link class="featured-item" to="/goods?category=201">
          <div class="featured-icon">👟</div>
          <span>Casuals</span>
        </router-link>
        <router-link class="featured-item" to="/goods?category=202">
          <div class="featured-icon">🥿</div>
          <span>Loafers</span>
        </router-link>
        <router-link class="featured-item" to="/goods?category=205">
          <div class="featured-icon">👢</div>
          <span>Boots</span>
        </router-link>
        <router-link class="featured-item" to="/goods?category=206">
          <div class="featured-icon">👟</div>
          <span>Sneakers</span>
        </router-link>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <div>
            <h2>New Arrivals</h2>
            <p>Fresh styles added every week</p>
          </div>
          <div class="section-header-right">
            <router-link class="section-cta" to="/goods">Shop Now</router-link>
          </div>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹599 across India</p>
          </div>
          <div class="why-item">
            <div class="why-icon">✨</div>
            <h3>Premium Quality</h3>
            <p>Handcrafted with the finest materials</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free return & exchange</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payments</h3>
            <p>UPI, COD & card payments accepted</p>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Bestsellers</h2>
              <p>Top picks loved by our customers</p>
            </div>
            <div class="section-tabs-wrap">
              <div class="section-tabs">
                <span class="tab-item" :class="{active: discoverActive===201}" @click="discoverActive=201">CASUALS</span>
                <span class="tab-item" :class="{active: discoverActive===200}" @click="discoverActive=200">FORMALS</span>
                <span class="tab-item" :class="{active: discoverActive===202}" @click="discoverActive=202">LOAFERS</span>
              </div>
              <router-link class="section-cta" to="/goods">View All</router-link>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Offer</span>
            <h2>FOOTWEAR SALE</h2>
            <p>Up to 40% Off on Premium Men's Footwear</p>
            <router-link class="promo-btn" to="/goods">Shop Deals</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/8772120117474/img_00.jpg" alt="Sale" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Formal Collection</div>
              <div class="split-desc">
                Premium leather formal shoes — sharp, polished, and perfect for any occasion
              </div>
              <router-link class="section-cta" to="/goods">Shop Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/9198208516322/img_00.jpg" alt="Ethnic" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Casual & Loafers</div>
              <div class="split-desc">
                Relaxed sophistication — loafers, sneakers & slip-ons for every look
              </div>
              <router-link class="section-cta" to="/goods">Shop Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/8931557408994/img_00.jpg" alt="Casual" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as carouselsAPI from '@/api/carousels/'
import * as productsAPI from '@/api/products/'
import * as rankingAPI from '@/api/ranking/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据
      phonesList: [], // 手机商品列表
      televisionsList: [], // 小米电视商品列表
      applianceList: [], // 家电商品列表
      applianceHotList: [], //热门家电商品列表
      accessoryList: [], //配件商品列表
      accessoryHotList: [], //热门配件商品列表
      phoneShellsList: [], // 保护套商品列表
      chargersList: [], //充电器商品列表
      applianceActive: 1, // 家电当前选中的商品分类
      accessoryActive: 1, // 配件当前选中的商品分类
      discoverActive: 201, // Discover section active tab (CASUALS=201, FORMALS=200, LOAFERS=202)
      kurtasList: [],
      tshirtsList: [],
      blazersList: [],
      start: 0,
      limit: 4,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    heroImage() {
      if (this.carousels && this.carousels.length) {
        return this.carousels[0].img_path
      }
      return 'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/41490428/img_01.jpg'
    },
    discoverProducts() {
      if (this.discoverActive === 201) return this.kurtasList
      if (this.discoverActive === 200) return this.tshirtsList
      return this.blazersList
    }
  },
  watch: {
    // 家电当前选中的商品分类，响应不同的商品数据
    applianceActive: function(val) {
      // 页面初始化的时候把applianceHotList(热门家电商品列表)直接赋值给applianceList(家电商品列表)
      // 所以在切换商品列表时判断applianceHotList是否为空,为空则是第一次切换,把applianceList赋值给applianceHotList
      if (this.applianceHotList == '') {
        this.applianceHotList = this.televisionsList
      }
      if (val == 1) {
        // 1为热门商品
        this.applianceList = this.applianceHotList
        return
      }
      if (val == 2) {
        // 2为电视商品
        this.applianceList = this.televisionsList
        return
      }
    },
    accessoryActive: function(val) {
      // 页面初始化的时候把accessoryHotList(热门配件商品列表)直接赋值给accessoryList(配件商品列表)
      // 所以在切换商品列表时判断accessoryHotList是否为空,为空则是第一次切换,把accessoryList赋值给accessoryHotList
      if (this.accessoryHotList == '') {
        this.accessoryHotList = this.chargersList
      }
      if (val == 3) {
        // 1为热门商品
        this.accessoryList = this.accessoryHotList
        return
      }
      if (val == 2) {
        // 2为保护套商品
        this.accessoryList = this.phoneShellsList
        return
      }
      if (val == 1) {
        //3 为充电器商品
        this.accessoryList = this.chargersList
        return
      }
    }
  },
  activated() {
    // 获取首页数据
    this.load()
  },
  methods: {
    load() {
      carouselsAPI
        .listCarousels()
        .then(res => {
          if (res.status == 200) {
            this.carousels = res.data
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)
            
            // Find categories for Discover section
            this.getProduct(201, 'kurtasList')  // Men Casuals
            this.getProduct(200, 'tshirtsList')  // Men Formal
            this.getProduct(202, 'blazersList')  // Men Loafers
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      //获取热门家电
      rankingAPI
        .listElecRanking()
        .then(res => {
          if (res.status === 200) {
            this.applianceHotList = res.data
            this.applianceList = res.data
          } else {
            this.notifyError('Failed')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取热门配件
      rankingAPI
        .listAcceRanking()
        .then(res => {
          if (res.status === 200) {
            this.accessoryHotList = res.data
            this.accessoryList = res.data
          } else {
            this.notifyError('Failed')
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
      //获取男性鞋类列表
      this.getProduct(201, 'chargersList')  // Men Casuals

      this.getProduct(200, 'phonesList')  // Men Formal
      //获取鞋类列表
      this.getProduct(202, 'televisionsList')  // Men Loafers
      //获取凉鞋列表
      this.getProduct(203, 'phoneShellsList')  // Men Slippers
    },
    // Find categories for Discover section
    findDiscoverCategories() {
      // Men's shoe category IDs
      this.getProduct(201, 'kurtasList')  // Men Casuals
      this.getProduct(200, 'tshirtsList')  // Men Formal
      this.getProduct(202, 'blazersList')  // Men Loafers
    },
    selectCategory(id) {
      if (this.activeCategoryId === id) return
      this.activeCategoryId = id
      this.homeStart = 0
      this.fetchHomeProducts(id)
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data.items) ? res.data.items : []
            // Shuffle the product list
            this.homeProducts = this.shuffleArray(list)
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle algorithm
    shuffleArray(array) {
      const shuffled = [...array]
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
      }
      return shuffled
    },
    // 获取家电模块子组件传过来的数据
    getChildMsg(val) {
      this.applianceActive = val
    },
    // 获取配件模块子组件传过来的数据
    getChildMsg2(val) {
      this.accessoryActive = val
    },
    // 获取各类商品数据方法封装
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = res.data.items
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F1F5F9')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F1F5F9')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';
</style>
